<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-7 my-4" style="color:#AF8936">
      <h2 class="hidden-sm-and-down">Asignar Tocas</h2>
      <div class="flex-grow-1"></div>
    </v-card-title>
      <v-card flat>
        <v-card-text>
          <h3>
            {{ currentParte.nombre }} {{ currentParte.primer_apellido }} {{ currentParte.segundo_apellido }}
          </h3>
          <v-container grid-list-md>
            <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
              <v-layout wrap v-for="(item, idx) in new_tocas">
                <v-flex xs4>
                  <v-text-field v-model="item.toca" label="Numero de Toca" :rules="tocaRules" :disabled="loading">
                  </v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-select :disabled="loading"
                    v-if="roleUser <= 3"
                    :items="salasList"
                    v-model="item.sala"
                    label="Sala"
                    item-value="id"
                    item-text="nombre"
                    :rules="notBlankRules"
                    >
                  </v-select>
                  <!-- <v-text-field v-model="toca" label="Numero de Toca" :rules="notBlankRules">
                  </v-text-field> -->
                </v-flex>
                 <v-card-actions xs4>
                  <v-btn v-if="new_tocas.length>1" color="grey lighten-1" dark @click.native="removeToca(idx)">Eliminar</v-btn>
                </v-card-actions>

              </v-layout>
              <v-card-actions xs4>
                  <!-- <v-btn color="grey lighten-1" dark @click.native="close_toca">Cancelar</v-btn> -->
                  <v-btn color="yellow darken-2" @click.native="addToca()" :loading="loading" :disabled="loading" class="white--text">Agregar</v-btn>
                </v-card-actions>
            </v-form>
            <v-card-actions xs4>
                  <v-spacer></v-spacer>
                  <!-- <v-btn color="grey lighten-1" dark @click.native="close_toca">Cancelar</v-btn> -->
                  <v-btn color="green darken-2" @click.native="saveTocas()" :loading="loading" :disabled="loading" class="white--text">Finalizar</v-btn>
                </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
      <v-divider></v-divider>
      <v-card>
        <div v-if="showAlert">
          <v-alert
            prominent
            outlined
            type="error"
           >
            <v-row align="center">
              <v-col class="grow hidden-xs-only">No hay TOCAS registrados para esta parte</v-col>
              <v-col class="grow hidden-sm-and-up">No hay registros.</v-col>
            </v-row>
          </v-alert>
        </div>
        <div v-if="showInfo">
          <v-alert
            prominent
            outlined
            type="warning"
           >
            <v-row align="center">
              <v-col class="grow hidden-xs-only">Los siguientes tocas ya estaban asignados: {{ infoMessage }}</v-col>
            </v-row>
          </v-alert>
        </div>


          <template v-if="showTabla">
            <v-card-title  style="color:#AF8936">
              <h5>{{ titleTabla }}</h5>
              <v-spacer></v-spacer>
              <h5>Total de tocas: {{resultTocas.length}}</h5>
            </v-card-title>
            <v-data-table
              :loading="loadingTable"
              hide-default-footer
              :headers="headers"
              :items="resultTocas"
              item-key="id"
              disable-pagination
              class="elevation-1"
            >

            <template v-slot:item.eliminar="{ item }" >
              <v-btn v-if="roleUser <= 3" class="mx-2" x-small color="secondary" dark @click="deleteParteToca(item)">Eliminar</v-btn>
            </template>

            </v-data-table>

            <!-- <v-pagination
              v-model="pagination.current"
              :length="pagination.total"
              @input="buscarToca"
              >
            </v-pagination> -->

          </template>

          <v-overlay :value="overlay2">
             <v-progress-circular indeterminate size="64"></v-progress-circular>
           </v-overlay>

      </v-card>

    <br>

  </v-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');
  import { VueEditor } from "vue2-editor";
  export default {
    data: () => ({
      sala:'',
      toca: '',
      listPartes:[],
      sala_id: '',
      salasList:[],
      expanded: [],
      expand:false,
      isExpanded:false,
      singleExpand:true,
      showTabla: false,
      showAlert: false,
      showInfo: false,
      infoMessage: '',
      overlay:false,
      overlay2:false,
      partes_id:[],
      parte_id:'',
      pagination: {
        current: 1,
        total: 0
      },
      files:[],
      file:[],
      archivo:{
        encode:'',
        type:'',
        file_name:''
      },
      to:[],
      addParte: '',
      dialog: false,
      loadingTablePartes:false,
      loading:false,
      valid: true,
      titleTabla: 'TOCAS REGISTRADAS EN ESTA PARTE:',
      headers: [
        { text: 'Sala', value: 'sala', sortable: false, class: "title" },
        { text: 'Toca', value: 'identificador', sortable: false, class: "title" },
        // { text: 'Acciones', value: 'data-table-expand', sortable: false, class: "title" },
        { text: '', value: 'action', sortable: false },
        { text: '', value: 'eliminar', sortable: false }
        // { text: '', value: 'data-table-expand', sortable: false },
      ],
      headers_partes: [
        { text: 'Nombre Completo', value:'nombre', sortable: false },
        { text: 'Estatus', value: 'pivot.acceso', sortable: false },
        // { text: 'Acciones', value: 'status', sortable: false },
        { text: '', value: 'cancelar', sortable: false },
        { text: '', value: 'acuerdo', sortable: false }
      ],
      loadingTable: true,
      notificacion:{
        partes_generales:[],
        asunto:'',
        contenido:'',
        file:''
      },
      DefaultNotificacion:{
        partes_generales:[],
        asunto:'',
        contenido:'',
        file:''
      },
      tocaRules: [
        v => !!v || 'El campo es requerido',
        v => /^(\d+)(\/)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido',
      ],
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      new_tocas: [
        {
          toca: '',
          sala: ''
        }
      ],
    }),
    computed: {
      ...mapGetters([
        "resultTocas", "roleUser", "currentUser", "token_", 'currentParte'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Parte' : 'Editar Parte'
      },
    },
    mounted(){
      // Get parte toca
      //
      // console.log(this.$route.params.parte_id);
      this.getParte(this.$route.params.parte_id);
      // SE ENCARGA DE PONER LOS TOCAS EN LA TABLA

      this.getSalas();
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    methods: {
      // Obtenemos parte
      getParte(id){
        this.$store.dispatch("GET_PARTE", id)
        .then((response) => {
          this.loadingTable = false;
          this.buscarToca();
          //  con sole.log('response vista',response.data);
        })
        .catch(err => {
          console.log(err);
          // this.showAlert = true
          // this.showTabla = false
        });
      },
      buscarToca() {
        this.overlay2 = true
        this.$store.dispatch("GET_TOCAS_BY_PARTE", this.currentParte.id)
        .then((response) => {
          //console.log(response);
          this.overlay2 = false
          this.loadingTable = false
          //  console.log('data tocas',response.data.data.tocas.length);
          if (response.data.status == 'ok' && response.data.data.tocas.length) {
            this.showTabla = true
            this.showAlert = false
          } else {
            this.showAlert = true
            this.showTabla = false
          }
        })
        .catch(err => {
          this.overlay2 = false
          //console.log(err);
          this.showAlert = true
          this.showTabla = false
        });
      },
      getSalas() {
        this.$store
          .dispatch("GET_SALAS")
          .then((response) => {
            this.salasList = response.data.salas;//usar response para datos, se puede usar getters
            // console.log('salas',response);
          })
          .catch(err => {
            console.log(err);
            //this.showAlert(this.notification);
          });
      },
      addToca(){
        if (this.$refs.form.validate()) {
          this.new_tocas.push({
            toca:'',
            sala:''
          });
        }
      },
      removeToca(index){
        this.new_tocas.splice(index,1);
      },
      saveTocas(){
        if (this.$refs.form.validate()) {
          this.showInfo = false;
          this.loading = true;
          if(this.roleUser === 4){
            this.acuerdos_sala = this.currentUser.sala;
          }else{
            this.acuerdos_sala = this.sala_id
          }
          this.$store
            .dispatch("ADD_MULTIPLE_TOCAS",{
              parte_id: this.currentParte.id,
              'tocas': this.new_tocas,
            })
            .then((response) => {
              // Comprobamos que sea un 200
              if(response.status===200){
                Swal.fire({
                  icon: 'success',
                  title: 'Se Guardó Correctamente',
                  showConfirmButton: false,
                  timer: 1500
                })
                // Si la confirmación tiene mensajes
                console.log(response.data.data.mensajes);
                if(response.data.data.mensajes.length){
                  this.showInfo = true;
                  let cadena = '';
                  response.data.data.mensajes.forEach((element,index) => {
                    cadena = cadena+element;
                    if(index < (response.data.data.mensajes-1)){
                      cadena = cadena+',';
                    }
                  });
                  this.infoMessage = cadena
                }
              }else{
                // Mostramos el error
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: response.data.message,
                  showConfirmButton: false,
                  timer: 3000
                })
              }
              // si es 400 mostramos el error
              this.buscarToca();
              this.new_tocas = [{
                toca: '',
                sala: ''
              }];
              this.loading = false;
              
              // this.buscarParte();
            })
            .catch((error) => {
              console.log('error',error);
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: error.response.data.message,
                  showConfirmButton: false,
                  timer: 1500
                })
                this.loading = false;
              //this.showAlert(this.notification);
            });

        }
      },

      deleteParteToca(item) {
        this.loadingTablePartes = true
        this.overlay2 = true
        this.$store
          .dispatch("DELETE_PARTE_TOCA", {
            toca_id: item.pivot.toca_id,
            parte_id:item.pivot.parte_id
          })
          .then((response) => {
            this.loadingTablePartes = false
            this.overlay2 = false
            console.log(response);
          if (response.data.status == 'ok') {
            // if(response.data.data.toca){
              Swal.fire({
                icon: 'success',
                title: 'Se Elimino Toca',
                showConfirmButton: false,
                timer: 1500
              })
              this.buscarToca();
          } else if(response.data.status == 'error'){
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response.data.data,
              showConfirmButton: false,
              timer: 1500
            })
          }
          })
          .catch(err => {
            this.loadingTablePartes = false
            this.overlay2 = false
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data,
              showConfirmButton: false,
              timer: 1500
            })
          });
        },

      close () {
        setTimeout(() => {
          this.notificacion = Object.assign({}, this.DefaultNotificacion)
          this.dialog = false
          this.overlay = false
          this.to = []
          this.file = []
          this.notificacion.partes_generales = []
          this.partes_id = []
          this.parte_id =''
          this.toca_id=''
        }, 300)

      },
  }
};
</script>
